import React from 'react'

// a line-break opportunity (not a character, so copying the address stays
// clean) right before the @, so a long address can wrap there
function renderEmail(email) {
  const at = email ? email.indexOf('@') : -1
  if (at === -1) return email
  return (
    <React.Fragment>
      {email.slice(0, at)}
      <wbr />
      {email.slice(at)}
    </React.Fragment>
  )
}

// An address in the offer screens' email box, with an edit button on its
// right that starts updating that address. onEdit omitted (e.g. once the
// screen is showing its confirmed state) hides the button.
const EmailVerificationEmailRow = (props) => {
  const { email, onEdit, editAriaLabel } = props

  return (
    <div className='emailVerificationFlow-emailBox-row'>
      <div className='emailVerificationFlow-emailDisplay'>{renderEmail(email)}</div>
      {onEdit && (
        <button
          type='button'
          className='emailVerificationFlow-emailBox-editBtn'
          onClick={onEdit}
          aria-label={editAriaLabel}
        >
          <span className='emailVerificationFlow-emailBox-editBtn-label'>Edit</span>
        </button>
      )}
    </div>
  )
}

export default EmailVerificationEmailRow
